/* Components */

import TotalApplicationsWidget from '@/components/Rover/Widgets/TotalApplicationsWidget';
import Card from '@/components/UI/Card/index.tsx';
import PieChart from '@/components/UI/Charts/PieChart';
/* Services */
import { EApplicationStatus } from '@/features/ApplicationForm/constants';
import { useApplicationsGeoLocation } from '@/features/ApplicationForm/FormConfig/CR/CRDashboard/useApplicatiosGeoLocation';
import { convertIntoValueAndPercentage } from '@/features/ApplicationForm/FormConfig/helpers';
import { convertEnumToText, isObjectEmpty } from '@/utils';

export function CRAllApplications({ data }: { data?: Record<string, any> }) {
  const { widgetsData } = useApplicationsGeoLocation(data);

  return (
    <>
      <div className='my-4'>
        <section className='my-4 grid md:grid-cols-2 xl:grid-cols-4 gap-4'>
          <TotalApplicationsWidget count={widgetsData?.totalApplications ?? 0} />
        </section>
        <Card title='Status Summary'>
          <div className='grid grid-cols-8 gap-6 py-6 px-6'>
            {!isObjectEmpty(EApplicationStatus) &&
              Object.keys(EApplicationStatus).map((s: any) => (
                <div key={s} className='col-span-2 font-medium flex justify-between gap-6'>
                  <span>{convertEnumToText(EApplicationStatus[s as keyof typeof EApplicationStatus])}</span>
                  <span>{widgetsData?.statusSummary[s] ?? 0}</span>
                </div>
              ))}
          </div>
        </Card>
      </div>
      {/* <div className='my-4'>
        <ProjectLocationWidget
          applicationLocationList={widgetsData?.applicationLocationList}
        />
      </div> */}
      <div className='my-4'>
        <section className='grid md:grid-cols-2 xl:grid-cols-2 gap-4 mt-4'>
          <Card title='Marital Status'>
            <div className='p-5 flex flex-col items-center '>
              <div className='w-5/6 lg:w-5/5 h-80'>
                <PieChart
                  labels={widgetsData?.maritalStatus?.label}
                  datasets={convertIntoValueAndPercentage(widgetsData?.maritalStatus?.dataSets)}
                  showValueAndPercentage
                  chartTitle=''
                />
              </div>
            </div>
          </Card>
          <Card title='Income Breakdown'>
            <div className='p-5 flex flex-col items-center '>
              <div className='w-5/6 lg:w-5/5 h-80'>
                <PieChart
                  labels={widgetsData?.totalRaces?.label}
                  datasets={convertIntoValueAndPercentage(widgetsData?.totalRaces?.dataSets)}
                  showValueAndPercentage
                  chartTitle=''
                />
              </div>
            </div>
          </Card>
        </section>
        <section className='grid md:grid-cols-2 xl:grid-cols-2 gap-4 mt-4'>
          <Card title='Gender'>
            <div className='p-5 flex flex-col items-center '>
              <div className='w-5/6 lg:w-5/5 h-80'>
                <PieChart
                  labels={widgetsData?.gender?.label}
                  datasets={convertIntoValueAndPercentage(widgetsData?.gender?.dataSets)}
                  showValueAndPercentage
                  chartTitle=''
                />
              </div>
            </div>
          </Card>
          <Card title='Race'>
            <div className='p-5 flex flex-col items-center '>
              <div className='w-5/6 lg:w-5/5 h-80'>
                <PieChart
                  labels={widgetsData?.totalRaces?.label}
                  datasets={convertIntoValueAndPercentage(widgetsData?.totalRaces?.dataSets)}
                  showValueAndPercentage
                  chartTitle=''
                />
              </div>
            </div>
          </Card>
        </section>
        <section className='grid md:grid-cols-2 xl:grid-cols-2 gap-4 mt-4'>
          <Card title='House Built Before 1978'>
            <div className='p-5 flex flex-col items-center '>
              <div className='w-5/6 lg:w-5/5 h-80'>
                <PieChart
                  labels={widgetsData?.totalHouseBuiltBefore1978?.label}
                  datasets={convertIntoValueAndPercentage(widgetsData?.totalHouseBuiltBefore1978?.dataSets)}
                  showValueAndPercentage
                  chartTitle=''
                />
              </div>
            </div>
          </Card>
          <Card title='Female Head of Household'>
            <div className='p-5 flex flex-col items-center '>
              <div className='w-5/6 lg:w-5/5 h-80'>
                <PieChart
                  labels={widgetsData?.totalFemaleHeadOfHouseHold?.label}
                  datasets={convertIntoValueAndPercentage(widgetsData?.totalFemaleHeadOfHouseHold?.dataSets)}
                  showValueAndPercentage
                  chartTitle=''
                />
              </div>
            </div>
          </Card>
        </section>
      </div>
    </>
  );
}
